module.exports = function getResource(label, vars = []) {
    const resources = {
        add: 'Add',
        new: 'New'
    };
    return resources[label];
};
